module.exports = __webpack_public_path__ + "media/intro-scaled.690d83d0.mp4";